import { IconColorSet } from "./IconColorSet";

export class IconColor {
  name: string;
  color: string;

  constructor(name: string, color: string) {
    this.name = name;
    this.color = color;
  }

  static fromJSON(json: any): IconColor {
    let name = json.name ?? "Default";
    let color = json.color ?? "";
    return new IconColor(name, color);
  }

  static from(string: string): IconColor {
    let value = string.toLocaleLowerCase();
    let name;
    let color;

    if (value === IconColorSet.gray) {
      name = "Default";
      color = "var(--icon-gray-color)";
    } else if (value === IconColorSet.red) {
      name = "Red";
      color = "var(--icon-red-color)";
    } else if (value === IconColorSet.orange) {
      name = "Orange";
      color = "var(--icon-orange-color)";
    } else if (value === IconColorSet.yellow) {
      name = "Yellow";
      color = "var(--icon-yellow-color)";
    } else if (value === IconColorSet.green) {
      name = "Green";
      color = "var(--icon-green-color)";
    } else if (value === IconColorSet.mint) {
      name = "Mint";
      color = "var(--icon-mint-color)";
    } else if (value === IconColorSet.blue) {
      name = "Blue";
      color = "var(--icon-blue-color)";
    } else if (value === IconColorSet.purple) {
      name = "Purple";
      color = "var(--icon-purple-color)";
    } else if (value === IconColorSet.pink) {
      name = "Pink";
      color = "var(--icon-pink-color)";
    } else if (value === IconColorSet.grayishBlue) {
      name = "Grayish Blue";
      color = "var(--icon-grayish-blue-color)";
    } else {
      name = "Default";
      color = "var(--icon-gray-color)";
    }

    return new IconColor(name, color);
  }
}
